import {EmbeddedReportAndDashboardView} from "../edit/EmbeddedReportAndDashboardView";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function drawReport(userDashboardChartLine, h, w, widget) {
    let embedRepView = new EmbeddedReportAndDashboardView({
        owner: {
            rootElement: () => {
                return widget.parent();
            },
        },
        viewHeight: h,
        viewWidth: w,
        embeddedInDashBoard: true,
        block: {
            id: calcChartTitle(userDashboardChartLine),
            reportInfo: userDashboardChartLine.repoInfo
        }
    });
    widget.attr("id", embedRepView.elementId);
    widget.width(w);
    widget.height(h);
    embedRepView.afterAttach();
    return widget;
}